<template>
    <div class="gs-checkout-rule-editor">
        <section class="gs-checkout-default-card">
            <div class="gs-checkout-default-card__copy">
                <small>Checkout language</small>
                <h4>Choose the language experience buyers see at checkout.</h4>
                <p>Keep this simple unless you are intentionally localizing a checkout for a specific market.</p>
            </div>
            <div class="gs-checkout-default-card__body">
                <div class="gs-checkout-choice-row">
                    <button
                        v-for="languageType in languageTypes"
                        :key="languageType.id"
                        type="button"
                        class="gs-checkout-choice"
                        :class="{ 'is-selected': localModel.checkout_page_options.language.type == languageType.id, 'is-disabled': languageType.coming_soon }"
                        @click="!languageType.coming_soon && (localModel.checkout_page_options.language.type = languageType.id)"
                    >
                        <span></span>
                        <strong>{{ languageType.title }}</strong>
                        <em>{{ languageType.description }}</em>
                    </button>
                </div>
                <div v-if="localModel.checkout_page_options.language.type == 1" class="gs-checkout-inline-fields">
                    <label>
                        <span>{{ $t('frontend_product_step5_select_language') }}</span>
                        <gd-dropdown
                            v-model="localModel.checkout_page_options.language.languages[0]"
                            size="full"
                            :options="languagesAvailableOptions"
                        />
                    </label>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    props: {
        model: {
            type: Object,
            required: true,
        },

    },
    data() {
        return {
            localModel: this.model,
            languageTypes: [
                {
                    id: 1,
                    title: this.$t('frontend_product_step5_language_types0_title'),
                    description: this.$t('frontend_product_step5_language_types0_desc'),
                },
                {
                    id: 2,
                    title: this.$t('frontend_product_step5_language_types1_title'),
                    description: this.$t('frontend_product_step5_language_types1_desc'),
                    coming_soon: true,
                },
            ],
        };
    },
    computed: {
        languagesAvailable() {
            return [
                { code: 'en', name: this.$t('frontend_product_step5_english') },
                { code: 'pt', name: this.$t('frontend_product_step5_portuguese') }
            ];
        },
        languagesAvailableOptions() {
            return this.languagesAvailable.map((language) => {
                return {
                    value: language.code,
                    text: language.name,
                };
            });
        },
    },
    watch: {
        localModel: {
            handler() {
                this.$emit('update-model', this.localModel);
                this.$emit('updateModel', this.localModel);
            },
            deep: true,
        },
    },

}
</script>
